export const commonTranslations = {
  user_administration: 5241,
  delete_item: 5539,
  delete_user_title: 9359,
  delete_user_desc: 7566,
  user_successfully_deleted: 8008,
  delete_role_title: 8049,
  delete_role_desc: 8051,
  role_successfully_deleted: 8050,
  duplicate_user: 8244,
  duplicate_role: 8424,
  search: 7345,
  disabled: 5251,
  cancel: 3273,
  save: 5564,
  default_role_title: 8855,
  default_role_description: 8854,

  merge_user_description: 9394,
  merge_user_sub_description: 9395,
  merge_user_validation_message: 9396,
  merge_user_include_disabled: 9397,
  merge_user_search: 9398
};

export const ids = {
  users: {
    name: 'user-name',
    email_address: 'user-email',
    user_id: 'user-user-id',
    disabled_date: 'user-disabled-date',
    latest_activity: 'latest-activity',
    change_password_button: 'user-change-password-button',
    user_type: 'user-type',
    main_user_group: 'main-user-group',
    current_user_group: 'current-user-group',
    unit: 'user-unit',
    location: 'user-location',
    default_language: 'user-default-language',
    add_button: 'add-new-user-button',
    export_excel: 'export-user-excel',
    cancel_button: 'user-cancel-button',
    save_button: 'user-save-button',
    invite_veracity_user_button: 'invite-veracity-user-link'
  },
  roles: {
    id: 'role-id',
    name: 'role-name',
    add_button: 'add-new-role-button',
    cancel_button: 'role-cancel-button',
    save_button: 'role-save-button',
    export_excel: 'export-role-excel'
  },
  search: {
    box: 'search-box-area',
    tile: 'search-tile',
    personId: 'search-tile-person-id'
  },
  number_of_hits: 'number-of-hits',
  no_hits: 'no-hits',
  list_search: 'list-search',
  list_search_item: (id) => `list-search-item-${id}`
};
